import React, { Component } from "react";
import { LOG_EVENT_TYPES } from "./appConstants";
import appHistory from "./appHistory";
import PageError from "./PageError";
import { Loader } from "../components/Loader/Loader";
import { connect, } from "react-redux";
import { Dispatch } from "redux";
import { appLog } from "./appActions";

interface IErrorBoundary {
    children: JSX.Element | JSX.Element[],
    dispatch: Dispatch,
    from?: string,
    headerText: string,
    linkText: string,
}

class ErrorBoundary extends Component<IErrorBoundary, { error: boolean | Error, from: string }> {
    private _ismounted: boolean = false;

    constructor(props: IErrorBoundary) {
        super(props);
        this.state = {
            error: false,
            from: this.props.from || 'web',
        };
        appHistory.listen((location) => {
            if (this._ismounted) {
                this.setState({
                    error: false,
                })
            }
        });
    }

    componentDidMount() {
        this._ismounted = true;
    }

    componentWillUnmount() {
        this._ismounted = false;
    }

    processChunkLoadError(error: Error) {
        window.location.reload();
    }

    componentDidCatch(error: Error, errorInfo: { componentStack: any; }) {
        if (
            error.name === 'ChunkLoadError' ||
            error.message?.includes('Failed to fetch dynamically imported module') ||
            error.message?.includes('Importing a module script failed') ||
            error.message?.includes('error loading dynamically imported module')
        ) {
            this.processChunkLoadError(error);
        } else {
            this.props.dispatch(appLog({
                type: LOG_EVENT_TYPES.exception,
                payload: {
                    error,
                    stack: errorInfo.componentStack,
                    string: error.toString(),
                    stringify: JSON.stringify(error),
                }
            }));
            if (this._ismounted) {
                this.setState({ error: error });
            }
        }
    }

    render() {
        const { headerText = 'Something went wrong', linkText } = this.props;
        if (typeof this.state.error !== "boolean" && this.state.error.name === 'ChunkLoadError') {
            return <Loader show/>
        } else if (this.state.error) {
            return <PageError linkText={linkText} headerText={headerText} code={500} error={this.state.error}/>
        } else {
            return <>{this.props.children}</>;
        }
    }
}

export default connect()(ErrorBoundary);
